import { SINGLE, QUADRUPLE } from "../../../constants/numbers.consts.js";
export const getHtmlInputSx = ({ open }) => ({
    transition: ({ transitions }) => transitions.create(["width", "opacity"], { duration: transitions.duration.complex }),
    width: open ? "100%" : 0,
    opacity: open ? SINGLE : 0,
    marginLeft: "auto",
    "&::-webkit-search-cancel-button": {
        position: "relative",
        right: ({ spacing }) => spacing(SINGLE),
        marginLeft: ({ spacing }) => spacing(QUADRUPLE),
    },
    "&::-webkit-search-cancel-button:hover": {
        cursor: "pointer",
    },
});
